(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["luxdei-predictive-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('luxdei-predictive-search')) {

  class LuxdeiPredictiveSearch extends HTMLElement {

    constructor() {
      super();

      this.input =
        this.querySelector('.luxdei-search-input');

      this.form =
        this.querySelector('.luxdei-hero-search');

      this.results =
        this.querySelector('.luxdei-search-results');

      this.resultsContent =
        this.querySelector('.luxdei-search-results__content');

      this.status =
        this.querySelector('.luxdei-search-status');

      this.section =
        this.closest('.shopify-section');

      this.minChars =
        Number(this.dataset.minChars || 3);

      this.limit =
        Number(this.dataset.limit || 6);

      this.currency =
        this.dataset.currency ||
        window.Shopify?.currency?.active ||
        'EUR';

      this.abortController = null;
      this.debounceTimer = null;
      this.activeIndex = -1;

      this.onInput =
        this.onInput.bind(this);

      this.onKeyDown =
        this.onKeyDown.bind(this);

      this.onDocumentClick =
        this.onDocumentClick.bind(this);
    }


    connectedCallback() {

      if (!this.input) {
        return;
      }

      this.input.addEventListener(
        'input',
        this.onInput
      );

      this.input.addEventListener(
        'keydown',
        this.onKeyDown
      );

      document.addEventListener(
        'click',
        this.onDocumentClick
      );
    }


    disconnectedCallback() {

      this.input?.removeEventListener(
        'input',
        this.onInput
      );

      this.input?.removeEventListener(
        'keydown',
        this.onKeyDown
      );

      document.removeEventListener(
        'click',
        this.onDocumentClick
      );

      this.abortController?.abort();

      this.unlockSection();
    }


    onInput() {

      const query =
        this.input.value.trim();

      clearTimeout(
        this.debounceTimer
      );

      this.activeIndex = -1;

      if (
        query.length <
        this.minChars
      ) {
        this.abortController?.abort();

        this.closeResults();

        return;
      }

      this.debounceTimer =
        setTimeout(
          () => {
            this.search(query);
          },
          250
        );
    }


    async search(query) {

      this.abortController?.abort();

      this.abortController =
        new AbortController();

      try {

        const root =
          window.Shopify?.routes?.root ||
          '/';

        const params =
          new URLSearchParams({
            q: query,
            'resources[type]': 'product',
            'resources[limit]': String(this.limit),
            'resources[limit_scope]': 'all',
            'resources[options][unavailable_products]': 'last'
          });

        const response =
          await fetch(
            `${root}search/suggest.json?${params.toString()}`,
            {
              signal:
                this.abortController.signal,

              headers: {
                Accept:
                  'application/json'
              }
            }
          );

        if (!response.ok) {
          throw new Error(
            `Predictive search error: ${response.status}`
          );
        }

        const data =
          await response.json();

        const products =
          data?.resources?.results?.products ||
          [];

        if (
          this.input.value.trim() !==
          query
        ) {
          return;
        }

        this.renderResults(
          products,
          query
        );

      } catch (error) {

        if (
          error.name ===
          'AbortError'
        ) {
          return;
        }

        console.error(
          'Lux Dei predictive search:',
          error
        );

        this.closeResults();
      }
    }


    renderResults(
      products,
      query
    ) {

      this.resultsContent
        .replaceChildren();

      if (!products.length) {

        const empty =
          document.createElement('div');

        empty.className =
          'luxdei-search-message';

        empty.textContent =
          'Nessun prodotto trovato.';

        this.resultsContent
          .appendChild(empty);

        this.status.textContent =
          'Nessun prodotto trovato';

        this.openResults();

        return;
      }

      const fragment =
        document.createDocumentFragment();

      products.forEach(
        (product) => {

          const link =
            document.createElement('a');

          link.className =
            'luxdei-search-product';

          link.href =
            product.url;

          link.setAttribute(
            'role',
            'option'
          );

          const imageWrapper =
            document.createElement('div');

          imageWrapper.className =
            'luxdei-search-product__image';

          const imageUrl =
            product.featured_image?.url ||
            product.image;

          if (imageUrl) {

            const img =
              document.createElement('img');

            img.src =
              this.resizeShopifyImage(
                imageUrl,
                160
              );

            img.alt =
              product.featured_image?.alt ||
              product.title ||
              '';

            img.loading =
              'lazy';

            img.width = 80;
            img.height = 80;

            imageWrapper
              .appendChild(img);

          } else {

            const placeholder =
              document.createElement('div');

            placeholder.className =
              'luxdei-search-product__image-placeholder';

            imageWrapper
              .appendChild(placeholder);
          }

          const info =
            document.createElement('div');

          info.className =
            'luxdei-search-product__info';

          const title =
            document.createElement('p');

          title.className =
            'luxdei-search-product__title';

          title.textContent =
            product.title;

          info.appendChild(title);

          if (product.vendor) {

            const vendor =
              document.createElement('div');

            vendor.className =
              'luxdei-search-product__vendor';

            vendor.textContent =
              product.vendor;

            info.appendChild(vendor);
          }

          const price =
            document.createElement('div');

          price.className =
            'luxdei-search-product__price';

          price.textContent =
            this.formatMoney(
              product.price
            );

          link.append(
            imageWrapper,
            info,
            price
          );

          fragment.appendChild(link);
        }
      );

      const allResults =
        document.createElement('a');

      allResults.className =
        'luxdei-search-all';

      const root =
        window.Shopify?.routes?.root ||
        '/';

      const searchParams =
        new URLSearchParams({
          q: query,
          type: 'product',
          'options[prefix]': 'last'
        });

      allResults.href =
        `${root}search?${searchParams.toString()}`;

      allResults.textContent =
        `Vedi tutti i risultati per “${query}”`;

      fragment.appendChild(
        allResults
      );

      this.resultsContent
        .appendChild(
          fragment
        );

      this.status.textContent =
        `${products.length} prodotti trovati`;

      this.openResults();
    }


    formatMoney(value) {

      const amount =
        Number(value);

      if (
        Number.isNaN(amount)
      ) {
        return '';
      }

      try {

        return new Intl.NumberFormat(
          document.documentElement.lang ||
          'it-IT',
          {
            style: 'currency',
            currency: this.currency
          }
        ).format(amount);

      } catch (error) {

        return `${amount.toFixed(2)} ${this.currency}`;
      }
    }


    resizeShopifyImage(
      url,
      width
    ) {

      try {

        const imageUrl =
          new URL(
            url,
            window.location.origin
          );

        imageUrl.searchParams.set(
          'width',
          width
        );

        return imageUrl.toString();

      } catch (error) {

        return url;
      }
    }


    getOptions() {

      return Array.from(
        this.resultsContent
          .querySelectorAll(
            '.luxdei-search-product'
          )
      );
    }


    onKeyDown(event) {

      if (
        this.results.hidden
      ) {
        return;
      }

      const options =
        this.getOptions();

      if (!options.length) {
        return;
      }

      if (
        event.key ===
        'ArrowDown'
      ) {

        event.preventDefault();

        this.activeIndex =
          Math.min(
            this.activeIndex + 1,
            options.length - 1
          );

        this.setActiveOption(
          options
        );
      }

      if (
        event.key ===
        'ArrowUp'
      ) {

        event.preventDefault();

        this.activeIndex =
          Math.max(
            this.activeIndex - 1,
            0
          );

        this.setActiveOption(
          options
        );
      }

      if (
        event.key ===
          'Enter' &&
        this.activeIndex >= 0
      ) {

        event.preventDefault();

        options[
          this.activeIndex
        ].click();
      }

      if (
        event.key ===
        'Escape'
      ) {
        this.closeResults();
      }
    }


    setActiveOption(
      options
    ) {

      options.forEach(
        (
          option,
          index
        ) => {

          option.classList.toggle(
            'is-active',
            index ===
            this.activeIndex
          );

          option.setAttribute(
            'aria-selected',
            index ===
            this.activeIndex
              ? 'true'
              : 'false'
          );
        }
      );
    }


    onDocumentClick(event) {

      if (
        !this.contains(
          event.target
        )
      ) {
        this.closeResults();
      }
    }


    lockSection() {

      this.classList.add(
        'is-open'
      );

      if (this.section) {
        this.section.classList.add(
          'luxdei-search-section-open'
        );
      }
    }


    unlockSection() {

      this.classList.remove(
        'is-open'
      );

      if (this.section) {
        this.section.classList.remove(
          'luxdei-search-section-open'
        );
      }
    }


    openResults() {

      this.results.hidden =
        false;

      this.input.setAttribute(
        'aria-expanded',
        'true'
      );

      this.lockSection();
    }


    closeResults() {

      this.results.hidden =
        true;

      this.input.setAttribute(
        'aria-expanded',
        'false'
      );

      this.activeIndex =
        -1;

      this.unlockSection();
    }
  }


  customElements.define(
    'luxdei-predictive-search',
    LuxdeiPredictiveSearch
  );
}
  } catch(e) { console.error(e); }
})();

})();
